import React, {Component} from 'react';


export default class PieChartComponent extends Component {

    constructor(props){
        super(props);
        this.state = {
            stateDataList:[]
        }
    }

    componentWillReceiveProps = () => {
        this.setState({stateDataList:this.newListWithStartPoint()});
    }

    newListWithStartPoint = () => {
        //各要素に、開始地点の情報を入れていく
        let newDataList = this.props.dataList !== undefined ? this.props.dataList : [];        

        let storageOfRate = 0;
        for (let i = 0; i < newDataList.length; i++) {
            newDataList[i].startPoint = storageOfRate;
            newDataList[i].endPoint = storageOfRate + newDataList[i].rate;
            storageOfRate += newDataList[i].rate;
        }

        return newDataList;
    }

    //@param
    //x,y = 円の中心
    //r = 半径
    //rate = 割合

    piePathD = (x,y,r,startPercent,currentPercent) => {

        if(currentPercent - startPercent === 100) {
            //0-100つまりぴったり一周だと、描いてくれないので調整
            currentPercent -= 0.00001; 
        }

        const startRad = 2 * Math.PI * (startPercent / 100) - (Math.PI / 2);

        const currentRad = 2 * Math.PI * (currentPercent / 100)- (Math.PI / 2);

        const start = {
            x: r * Math.cos(startRad) + x,
            y: r * Math.sin(startRad) + y,
        }

        const goal = {
            x: r * Math.cos(currentRad) + x,
            y: r * Math.sin(currentRad) + y,
        }

        let large_arc_flag;
        if(currentPercent - startPercent < 50){
            //円弧が180度より大きいか小さいかを判定する
            large_arc_flag = 0;
        }else{
            large_arc_flag = 1;
        }

        const pathD = 'M ' + x + ',' + y 
                      + ' L ' + start.x + ',' + start.y
                      + ' A ' + r + ',' + r + ' 0 ' + large_arc_flag + ',1 ' + goal.x + ',' + goal.y + ' Z';
        
        return pathD;
    }

    render() {


        return (
            <div className='pieChartArea' style={{lineHeight:0}}>
              <svg xmlns="http://www.w3.org/2000/svg" version="1.1" width="100%" height="100%" viewBox="0 0 80 80"
              style={this.state.svgStyle}>
                {this.state.stateDataList.map((value,index) => {
                    return (
                        <path d={this.piePathD(40,40,40,value.startPoint,value.endPoint)} fill={value.color} key={index} />
                    )
                })}
                <path d={this.piePathD(40,40, (40 * this.props.holeSizePercent / 100) ,0,100)} fill={this.props.holeColor} />
              </svg>
            </div>
        )
    }

};

// Propsのデフォルト値
PieChartComponent.defaultProps = {
    dataList:[
        {rate:60,color:'hsl(6,77%,62%)'},
        {rate:22,color:'#Edad0b'},
        {rate:18,color:'#666666'}
    ],
    holeSizePercent:0,
    holeColor:'#ffffff',
};


//svg学習結果

//path A
// Aのパラメータ = A (rx,ry) x-axis-rotation (large-arc-flag,sweep-flag) (x,y)
//rx,ry = 半径（楕円）、正円なら同値
//x-axis-rotation = 円弧の回転度らしい。よくわからん
//large-arc-flag = sweep-flagで決まった円で、2点を結ぶ軸から180度より大きい方かどうかを決める
//sweep-flag = 2点を通る円は2パターンあるので、そのどちらかか
//x,y = 円の終点。

//現地点から、x,yに向けて円を描く、